import {
  createFrontendModule,
  PageBlueprint,
} from '@backstage/frontend-plugin-api';
import { SignInPageBlueprint } from '@backstage/plugin-app-react';
import { WorkbenchSignInPage } from './SignInPage';

const signInPage = SignInPageBlueprint.make({
  params: {
    loader: async () => WorkbenchSignInPage,
  },
});

// Mounted at `/` in place of the disabled plugin-home page so the Workbench
// opens on Explore. Explore stays at `/explore` so its sub-routes still work.
const rootRedirectPage = PageBlueprint.make({
  name: 'root-redirect',
  params: {
    path: '/',
    loader: async () => {
      const { RootRedirect } = await import('./RootRedirect');
      return <RootRedirect />;
    },
  },
});

export const appModule = createFrontendModule({
  pluginId: 'app',
  extensions: [
    signInPage,
    rootRedirectPage,
  ],
});